import { SymbolType } from 'data/Instrument/types'
import { TradeType } from 'data/types'

import * as AT from './actionTypes'

export type StopTradesActionType = {
  payload: { readonly symbol: SymbolType }
  type: typeof AT.STOP
}

export type RecentTradesActionType = {
  payload: { readonly recentTrades: Array<TradeType> }
  type: typeof AT.SET_RECENT_TRADES
}

export type TradesActionType =
  | { type: typeof AT.RESET }
  | { type: typeof AT.SET_SUBSCRIBED }
  | {
      payload: { readonly trade: TradeType }
      type: typeof AT.SET_UPDATE
    }
  | RecentTradesActionType
  | StopTradesActionType

const reset = (): TradesActionType => ({
  type: AT.RESET
})

const setSubscribed = (): TradesActionType => ({
  type: AT.SET_SUBSCRIBED
})

const setUpdate = (trade: TradeType): TradesActionType => ({
  payload: { trade },
  type: AT.SET_UPDATE
})

const setRecentTrades = (recentTrades: Array<TradeType>): RecentTradesActionType => ({
  payload: { recentTrades },
  type: AT.SET_RECENT_TRADES
})

const stop = (symbol: SymbolType): TradesActionType => ({
  payload: { symbol },
  type: AT.STOP
})

export default {
  reset,
  setRecentTrades,
  setSubscribed,
  setUpdate,
  stop
}
